import { TextInput, Checkbox, MultilineInput, Line } from "@tblabs/truffle";
import { ToDo } from "../../Components/ToDo";
import { DateSlider } from "../../Components/Utils/DateSlider";
import { Step } from "../Step/Step";
import { Cash } from "../Step/Cash";
import { StepEvent, StepEventType } from "../Step/StepEvent";
import { StepType } from "../Step/StepType";
import { EventStepData } from "./Models/EventStepData";
import { EventStepState } from "./Models/EventStepState";
import { TimeUtils } from "../../Utils/TimeUtils";
import { DateTimeProvider } from "../../Services/DateTimeProvider";
import { CashType } from "../Step/CashType";


export class EventStep extends Step<EventStepState>
{
    public Type = StepType.Event;
    public Icon = "⚡";
    public TitleForCustomer = () => this.Data.Title.value;
    public Title = () => this.Data.Title.value;

    public InitialState = EventStepState.Preparing;
    public WellDoneStates = [EventStepState.Executed, EventStepState.Omitted];
    public FailedDoneStates = [EventStepState.Canceled];

    public get AsEvents(): StepEvent[]
    {
        return [
            new StepEvent(StepEventType.Event, this.Order.Id, "⚡", this.Data.Title.value, this.Data.PlannedTime.value, this.IsDone, this.Data.VisibleForCustomer.value)
        ];
    }
    public get Mana(): Cash[]
    {
        const cash: Cash[] = [];

        if (this.Data.State.Is(EventStepState.Executed))
        {
            if (this.Data.Profit.value > 0)
                cash.push(new Cash(CashType.ReceivedIncome, this, this.Data.Profit.value, "Profit", new Date(+this.Data.ExecutionTime.value)));
            if (this.Data.Cost.value > 0)
                cash.push(new Cash(CashType.Expense, this, this.Data.Cost.value, "Koszt", new Date(+this.Data.ExecutionTime.value)));
        }

        return cash;
    }
    public get WhenPlanned(): Date
    {
        return this.Data.PlannedTime.value;
    }
    public get WhenDone(): Date
    {
        return this.Data.ExecutionTime.value;
    }

    constructor(public Data: EventStepData)
    {
        super(Data);
    }

    public STATES = {
        [EventStepState.Preparing]: {
            StateName: "W przygotowaniu",
            Customer: {
                Content: () => [`W przygotowaniu...`],
            },
            Admin: {
                Content: () => [
                    new ToDo(
                        `Dodaj informacje o zdarzeniu:\n\n`,
                        new Checkbox(this.Data.VisibleForCustomer, "Widoczne dla klienta"),
                        new TextInput(this.Data.Title).Placeholder("Tytuł zadania"),
                        new MultilineInput(this.Data.Info).Rows(3).Placeholder("Informacja o zadaniu (widoczna również dla klienta)"),
                        "\nPlanowane na: ",
                        new DateSlider(this.Data.PlannedTime))],
                Actions: {
                    "✅": () => this.GoTo(EventStepState.Incoming),
                    "❌": () => this.GoTo(EventStepState.Canceled),
                },
            }
        },
        [EventStepState.Incoming]: {
            StateName: "Zaplanowane",
            Timeout: () => this.Data.PlannedTime,
            Customer: {
                Content: () => [
                    this.Data.Info.value,
                    new Line(),
                    +this.Data.PlannedTime.value > 0 && `☑️ Zaplanowane na ${TimeUtils.FormattedDateTime(this.Data.PlannedTime)}`],
            },
            Admin: {
                Content: () => [this.Data.Info.value, new Line(), `☑️ Zaplanowane na ${TimeUtils.FormattedDateTime(this.Data.PlannedTime)}`],
                Actions: {
                    "✅": () => { this.Data.ExecutionTime.value = DateTimeProvider.Now; this.GoTo(EventStepState.Executed) },
                    "❌": () => this.GoTo(EventStepState.Canceled),
                },
            },
        },
        [EventStepState.Executing]: {
            StateName: "W toku",
            Customer: {
                Content: () => [`Zadanie jest właśnie realizowane`],
            },
            Admin: {
                Content: () => [this.Data.Info.value, ` - jest w trakcie realizacji`],
                Actions: {
                    "✅": () => { this.Data.ExecutionTime.value = DateTimeProvider.Now; this.GoTo(EventStepState.Executed) },
                    "❌": () => this.GoTo(EventStepState.Canceled),
                },
            }
        },
        [EventStepState.Executed]: {
            StateName: "Zrealizowane",
            Customer: {
                Content: () => [this.Data.Info.value, new Line(), `✅ Zrealizowane ${TimeUtils.FormattedDateTime(this.Data.ExecutionTime)}`],
            },
            Admin: {
                Content: () => [this.Data.Info.value, new Line(), `✅ Zrealizowane ${TimeUtils.FormattedDateTime(this.Data.ExecutionTime)}`],
            }
        },
        [EventStepState.Canceled]: {
            StateName: "Anulowane",
            Customer: {
                Content: () => [`❌ Anulowane`],
            },
            Admin: {
                Content: () => [this.Data.Info.value, new Line(), `❌ Anulowane`],
            }
        },
        [EventStepState.Omitted]: {
            StateName: "Pominięte",
            Customer: {
                Content: () => [`✖️ Pominięte`],
            },
            Admin: {
                Content: () => [this.Data.Info.value, new Line(), `✖️ Pominięte`],
            }
        }
    };
}
